import { render, staticRenderFns } from "./VesselCourseUnknownDanger.vue?vue&type=template&id=78879630&"
import script from "./VesselCourseUnknownDanger.vue?vue&type=script&lang=js&"
export * from "./VesselCourseUnknownDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports